import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { cx } from "shared/utils/classnames";
import { SVGComponentProps } from "untitledui-js-base";

export const NavLink: FC<{
  to?: string;
  onClick?: () => void | unknown;
  children: React.ReactNode;
  Icon?: FC<SVGComponentProps>;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  className?: string;
}> = ({ to, children, Icon, target, onClick, rel, className: _className }) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  const className = cx(
    "text-sm font-medium flex gap-3 w-full whitespace-nowrap text-ellipsis overflow-hidden break-all items-center p-3 rounded-lg transition-all no-underline my-[2px]",
    isActive
      ? "text-primary-600 stroke-primary-500 bg-primary-20"
      : "text-content-500 stroke-content-500 hover:bg-alpha-40",
    _className
  );

  if (!to)
    return (
      <button
        type="button"
        onClick={() => onClick && onClick()}
        className={className}
      >
        {Icon ? <Icon className="shrink-0" size="20" stroke="inherit" /> : null}
        {children}
      </button>
    );

  if (target)
    return (
      <a href={to} target={target} rel={rel} className={className}>
        {Icon ? <Icon className="shrink-0" size="20" stroke="inherit" /> : null}
        {children}
      </a>
    );

  return (
    <Link to={to} className={className}>
      {Icon ? <Icon className="shrink-0" size="20" stroke="inherit" /> : null}
      {children}
    </Link>
  );
};
